import React, { useEffect, useState } from "react";
import styles from "./Filter.module.scss";
import CrossIconSVG from "components/SVGComponents/CrossIconSVG";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import ArrowSVG from "components/SVGComponents/ArrowSVG";
import toast from "react-hot-toast";
import { combineClasses } from "utils/utils";
import { useDispatch, useSelector } from "react-redux";
import { setFilters } from "reducer/admin/dashboardSlice";

const Filter = ({ setFilterModal = () => {} }) => {
  const dispatch = useDispatch();

  const { fromDate, toDate } = useSelector((state) => state.dashboard.filters);

  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth();

  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [selectedMonth, setSelectedMonth] = useState(currentMonth);
  const [calendarType, setCalendarType] = useState({
    year: false,
    month: false,
  });

  const resolvedMonth = selectedMonth ?? currentMonth;
  

  const getMonthName = (monthIndex) =>
    new Date(2000, monthIndex).toLocaleString("default", { month: "long" });

  const handleCalendarType = (type) => {
    setCalendarType({ ...calendarType, [type]: !calendarType[type] });
  };

  const handleYearChange = (date) => {
    const year = new Date(date).getFullYear();
    setSelectedYear(year);
    setCalendarType((prev) => ({ ...prev, year: false }));
  };

  const handleMonthChange = (date) => {
    const month = new Date(date).getMonth();
    setSelectedMonth(month);
    setCalendarType((prev) => ({ ...prev, month: false }));
  };

  const handleOverlayClick = () => {
    setFilterModal(false);
  };

  const handleSubmit = () => {
    // if (selectedYear !== null && selectedMonth !== null) {
    if (selectedYear !== null) {
      const fromDate = new Date(Date.UTC(selectedYear, resolvedMonth, 1));
      const toDate = new Date(
        Date.UTC(selectedYear, (selectedMonth ?? 11) + 1, 0)
      );

      const filters = {
        fromDate: fromDate.toISOString(),
        toDate: toDate.toISOString(),
      };
      dispatch(setFilters(filters));
      setFilterModal(false);
    } else {
      // toast.error("Please select both year and month.");
      toast.error("Please select year");
    }
  };

  const handleReset = () => {
    setSelectedYear(null);
    setSelectedMonth(null);
    setCalendarType({ year: false, month: false });
    dispatch(setFilters({ fromDate: "", toDate: "" }));
    setFilterModal(false);
  };

  const accordians = [
    {
      type: "year",
      label: "Select year",
      calendarProps: {
        view: "decade",
        onClickYear: handleYearChange,
        value: selectedYear ? new Date(selectedYear, 0, 1) : null,
        tileClassName: ({ date, view }) =>
          view === "decade" && date.getFullYear() === selectedYear
            ? styles.activeTile
            : null,
        tileDisabled: ({ date, view }) =>
          view === "decade" && date.getFullYear() > currentYear,
      },
      selectedValue: selectedYear,
    },
    {
      type: "month",
      label: "Select Month",
      calendarProps: {
        view: "year",
        onClickMonth: handleMonthChange,
        showNavigation: false,
        tileClassName: ({ date, view }) =>
          view === "year" &&
          selectedMonth !== null &&
          date.getMonth() === selectedMonth
            ? styles.activeTile
            : null,
        tileDisabled: ({ date, view }) =>
          view === "year" &&
          selectedYear === currentYear &&
          date.getMonth() > currentMonth,
      },
      selectedValue:
        selectedMonth !== null ? getMonthName(selectedMonth) : null,
    },
  ];

  useEffect(() => {
    if (fromDate) {
      const date = new Date(decodeURIComponent(fromDate));
      const dateTo = new Date(decodeURIComponent(toDate));
      const diff = (dateTo - date) / (1000 * 60 * 60 * 24);
      setSelectedYear(date.getFullYear());
      if (diff <= 31) {
        setSelectedMonth(date.getMonth());
      }
    }
  }, [fromDate, toDate]);

  return (
    <section className={styles.overlay} onClick={handleOverlayClick}>
      <div
        className={styles.filterContainer}
        onClick={(e) => e.stopPropagation()}
      >
        <div className={styles.filterTitle}>
          <h2>Filter</h2>
          <span onClick={() => setFilterModal(false)}>
            <CrossIconSVG color="#6570fc" />
          </span>
        </div>

        <div className={styles.calendarGrid}>
          {accordians.map((item) => (
            <div className={styles.accordian} key={item.type}>
              <div
                onClick={() => handleCalendarType(item.type)}
                className={styles.accordianTitle}
              >
                <span>
                  {item.selectedValue ? item.selectedValue : item.label}
                </span>
                <span
                  className={combineClasses(
                    styles.arrowIcon,
                    calendarType[item.type] && styles.active
                  )}
                >
                  <ArrowSVG />
                </span>
              </div>
              {calendarType[item.type] && <Calendar {...item.calendarProps} />}
            </div>
          ))}
        </div>

        <div className={styles.btnCover}>
          <button
            disabled={!fromDate}
            onClick={handleReset}
            className={styles.resetBtn}
          >
            Reset
          </button>
          <button onClick={handleSubmit} className={styles.applyBtn}>
            Apply
          </button>
        </div>
      </div>
    </section>
  );
};

export default Filter;
